import React, {Component} from "react";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import {ACTIVITY_TYPE} from "../../../common/Constants";

class CrmSystem extends Component {
    render() {
        const {options, controls, setValue, errors} = this.props;
        
        return (
            <>
                <div className="grid grid-3x gap-20px">
                    <div id="grid-1">
                        <SimpleInput
                            name="kodeCabang"
                            label="Kode Cabang"
                            readOnly
                            value={controls?.kodeCabang?.value}
                        />
                        <SimpleInput
                            name="prospectDate"
                            label="Tanggal Prospek"
                            readOnly
                            value={controls?.prospectDate?.value}
                        />
                        <SimpleInput
                            name="prospectId"
                            label="Nomor Prospek"
                            readOnly
                            value={controls?.prospectId?.value}
                        />
                        {this.props.box === "CDB" ? (
                            <>
                                <SimpleInput
                                    name="lastFUStatusH1"
                                    label="Status FU Terakhir H1"
                                    readOnly
                                    value={controls?.lastFUStatusH1?.value}
                                />
                                <SimpleInput
                                    name="lastFUStatusH23"
                                    label="Status FU Terakhir H23"
                                    readOnly
                                    value={controls?.lastFUStatusH23?.value}
                                />
                                <SimpleInput
                                    name="lastFUDate"
                                    label="Tanggal FU Terakhir"
                                    readOnly
                                    value={controls?.lastFUDate?.value}
                                />
                            </>
                        ) : (
                            <>
                                <SimpleDDL
                                    id="select_options_prospek_category"
                                    box="search"
                                    name="category"
                                    label="Kategori Prospek"
                                    mandatory
                                    errorMessage={errors?.category}
                                    readOnly={!(this.props.box === "FU" && this.props.activityType === ACTIVITY_TYPE.CREATE)}
                                    options={options.prospekCategoryOptions}
                                    value={controls?.category?.value || null}
                                    onChange={(value, {name}) => setValue(name, value)}
                                />
                            </>
                        )}
                    </div>
                    <div id="grid-2">
                        <SimpleDDL
                            id="select_options_prospek_source"
                            box="search"
                            name="source"
                            label="Asal Prospek"
                            mandatory
                            errorMessage={errors?.source}
                            readOnly={!(this.props.box === "FU" && this.props.activityType === ACTIVITY_TYPE.CREATE)}
                            options={options.prospekSourceCreateOptions}
                            value={controls?.source?.value || null}
                            onChange={(value, {name}) => setValue(name, value)}
                        />
                        <SimpleInput
                            name="sourceCabang"
                            label="Cabang Asal"
                            readOnly
                            value={controls?.sourceCabang?.value}
                        />
                        <SimpleInput
                            name="lastFollowUpBy"
                            label="Last Follow Up By"
                            readOnly
                            value={controls?.lastFollowUpBy?.value}
                        />
                        <SimpleDDL
                            id="select_options_prospek_type"
                            box="search"
                            name="type"
                            label="Jenis Prospek"
                            value={controls?.type?.value || null}
                            readOnly
                        />
                        {this.props.box === "CDB" && (
                            <>
                                <SimpleDate
                                    name="lastBuyDate"
                                    label="Tanggal Beli Terakhir"
                                    disabled
                                    date={controls?.lastBuyDate?.value}
                                />
                                <SimpleDate
                                    name="lastServiceDate"
                                    label="Tanggal Service Terakhir"
                                    disabled
                                    date={controls?.lastServiceDate?.value}
                                />
                            </>
                        )}
                    </div>
                    <div id="grid-3">
                        {this.props.box === "CDB" && (
                            <SimpleInput
                                name="sourceData"
                                label="Sumber Data"
                                readOnly
                                value={controls?.sourceData?.value}
                            />
                        )}
                        <SimpleInput
                            name="prospectOwnership"
                            label="Pemilik Prospek"
                            value={controls?.prospectOwnership?.value}
                            readOnly
                        />
                        <SimpleInput
                            name="lastSeller"
                            label="Penjual Terakhir"
                            readOnly
                            value={controls?.lastSeller?.value}
                        />
                        {this.props.box === "CDB" && (
                            <>
                                <SimpleDate
                                    name="lastLoginDate"
                                    label="Last Login Date"
                                    disabled
                                    date={controls?.lastLoginDate?.value}
                                />
                                <SimpleDate
                                    name="lastLoginTime"
                                    label="Last Login Time"
                                    disabled
                                    date={controls?.lastLoginTime?.value}
                                />
                            </>
                        )}
                    </div>
                </div>
            </>
        )
    }
}

export default CrmSystem;
